import './CSS_ke_log/CssForFIVEJS.css';
const Three = () => {
    return (
        <div className="csskabaap" id="pncilwala">
         <p> एंटीबायोटिक्स केवल बैक्टीरिया के खिलाफ काम करते हैं, वायरस नहीं।

COVID-19 एक वायरस के कारण होता है, और इसलिए रोकथाम या उपचार के लिए एंटीबायोटिक दवाओं का उपयोग नहीं किया जाना चाहिए।

हालाँकि, यदि आप COVID-19 के लिए अस्पताल में भर्ती हैं, तो आपको एंटीबायोटिक्स प्राप्त हो सकते हैं क्योंकि जीवाणु सह-संक्रमण संभव है | </p>
        </div>
    )
};

export default Three;